export default class PaPayrollController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayroll/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayroll/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/paPayroll/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayroll/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayroll/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayroll/delete', 'post', params, axiosOption, httpOption);
  }

  static submitAssess (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayroll/submitAssess', 'post', params, axiosOption, httpOption);
  }
  static submitBackAssess (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayroll/submitBackAssess', 'post', params, axiosOption, httpOption);
  }

  static accountingPayroll (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayroll/accountingPayroll', 'post', params, axiosOption, httpOption);
  }

  static lockedPayroll (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayroll/lockedPayroll', 'post', params, axiosOption, httpOption);
  }
}
